export const selectCanUpdate = state => state.canUpdate.data;
